// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5971":"1a30358e","6826":"fcd09509","7667":"3675ef97","9735":"3675ef97"}[chunkId] + ".chunk.css";
};